import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

import { shoppingType } from ".";

const { CART, BASKET } = shoppingType;
const ShoppingTypeContext = createContext(shoppingType.CART);

const ShoppingCartTypeProvider = ({ children }) => {
  return (
    <ShoppingTypeContext.Provider value={shoppingType.CART}>
      {children}
    </ShoppingTypeContext.Provider>
  );
};

const ShoppingBasketTypeProvider = ({ children }) => {
  return (
    <ShoppingTypeContext.Provider value={shoppingType.BASKET}>
      {children}
    </ShoppingTypeContext.Provider>
  );
};

const useShoppingType = () => useContext(ShoppingTypeContext);
ShoppingCartTypeProvider.propTypes = {
  children: PropTypes.node,
};

ShoppingBasketTypeProvider.propTypes = {
  children: PropTypes.node,
};

export {
  CART,
  BASKET,
  ShoppingCartTypeProvider,
  ShoppingBasketTypeProvider,
  useShoppingType,
};
